import { Trans, useLingui } from '@lingui/react/macro'
import { Box } from 'designSystem/components/Box'
import { CommandShortcut } from 'designSystem/components/Command'
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from 'designSystem/components/Sidebar'
import { useCommandPalette } from 'features/commandPalette/contexts/CommandPaletteContext'
import { COMMAND_PALETTE_SHORTCUT_LABEL } from 'features/commandPalette/utils/shortcut'
import { Search } from 'lucide-react'

/** Full-width row used when the sidebar has no Home / Chats switch. */
export function SidebarSearchMenuRow() {
  const { t } = useLingui()
  const { isEnabled, openCommandPalette } = useCommandPalette()
  const isCollapsed = useSidebar().state === 'collapsed'
  if (!isEnabled) return null

  return (
    <Box asChild flex='none'>
      <SidebarGroup>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              variant='embedded'
              tooltip={t`Search Cantilever (${COMMAND_PALETTE_SHORTCUT_LABEL})`}
              onClick={openCommandPalette}>
              <Search aria-hidden />
              {!isCollapsed && (
                <>
                  <span>
                    <Trans>Search</Trans>
                  </span>
                  <CommandShortcut>
                    {COMMAND_PALETTE_SHORTCUT_LABEL}
                  </CommandShortcut>
                </>
              )}
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroup>
    </Box>
  )
}
